export default {
    template: `<span f-if="params.value" class="use-type-renderer badge badge-light-success">{{ params.value }}</span>`,
    data: function () {
        return {

        }
    }
};
